import React from 'react'
import { NavLink } from 'react-router-dom'
import classes from './Customers.module.css'
import Search from './../common/Search/Search'
import UserInfoArea from '../common/UserInfoArea/UserInfoArea'
import {PrimaryButton} from './../common/buttons/buttons'
import {pageDefaultHeight} from './../common/sizes'
import CustomersTable from './CustomersTable'
import Select from '../common/Select/Select'
import {setTenantsListFilter, setTenantsSearchString} from "../../helpers/localStorage";

const Customers = (props) => {


  const onInputChange = (e) => {
    setTenantsSearchString(e.replace(/^\s+|\s+$/g, ''))
    props.onSearch(e.replace(/^\s+|\s+$/g, ''))
  }


  const onSelectChange = (value) => {
    props.setSelectedIsActive(value)
    setTenantsListFilter(value)
  }

  return (
    <>
      <header className={classes.header}>
        <Search onChange={(e) => onInputChange(e.target.value)} searchedValue={props.searchValue}/>
        <UserInfoArea />
      </header>
      <div className={classes.wrapper} style={{height:`${pageDefaultHeight}px`}}>
        <div className={classes.titleArea}>
          <h1 className={classes.pageTitle}>TENANTS LIST</h1>
          <div>
            <Select
              options={props.periodOptions}
              onSelect={(value) => onSelectChange(value)}
              style={{width: '200px', marginRight: '15px'}}
              value={props.selectedIsActive}
              className='smallSelect'
            />
            <NavLink to='/Tenants/add-tenant'>
              <PrimaryButton text='ADD TENANT'/>
            </NavLink>
          </div>
        </div>
        <CustomersTable
          customers={props.searchResults ? props.searchResults : props.customers}
          deleteCustomer={props.deleteCustomer}
          selectedIsActive={props.selectedIsActive}
        />
      </div>
    </>
  )
}

export default Customers
